export const state = {
  modalViewPaymentMethod: false,
  paymentMethods: [],
  paymentMethod: {}
};

export default {};
